import React, { type ReactNode } from 'react';
import { StrategyMenuButton } from './StrategyMenuButton';
type SlideFrameProps = {
  children: ReactNode;
  className?: string;
  dark?: boolean;
  eyebrow?: string;
  topBand?: boolean;
};
export function SlideFrame({
  children,
  className = '',
  dark = false,
  eyebrow,
  topBand = false
}: SlideFrameProps) {
  return <main className={`relative h-full w-full overflow-hidden ${dark ? 'bg-[#0A0A0A] text-[#F4F1E8]' : 'bg-[#F4F1E8] text-[#0A0A0A]'} ${className}`} data-id="element-307" data-mp="2wscgepzylsm3">
      {topBand ? <div className="absolute inset-x-0 top-0 h-[7.5vh] overflow-hidden bg-[#202F65]" aria-hidden="true" data-id="element-308" data-mp="35qefh004ub6q">
          <img src="https://cdn.magicpatterns.com/uploads/14w1KW49YPe8a56htQkCRS/Screenshot_2026-09-01_at_13.05.53.png" alt="" width="2546" height="426" loading="eager" decoding="async" className="w-full h-auto -translate-y-[62%] object-contain" data-id="element-309" data-mp="3ajhcxj8164s7" />
        </div> : null}
      <StrategyMenuButton data-id="element-310" data-mp="243mroejct2jf" />
      <div className={`absolute inset-x-[6%] bottom-[6%] flex flex-col ${topBand ? 'top-[10%]' : 'top-[6%]'}`} data-id="element-311" data-mp="243v1tyo3dtqx">
        {eyebrow ? <p className="mb-[2.4vh] font-sans text-[clamp(13px,1.1vw,21px)] font-semibold uppercase tracking-[0.28em] text-[#D62B22]" data-id="element-312" data-mp="1z6d1gwo54muj">
            {eyebrow}
          </p> : null}
        {children}
      </div>
    </main>;
}